var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlantDefaultImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#707070",
    className: "icon-leaf",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.09 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "No Plant Image Availabe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.1,59.49c-3.83-10.59-17.89-22.06-19.94-21.71-.21-1.23-11.14,15.1-8.16,29.38,2.47,11.85,13.22,16.65,17.94,17.98s5.74,5.9,7.54,8.86c.32,.55,1.14,.06,.82-.48-2.06-3.54-2.48-7.54-.76-11.53s6.38-11.91,2.55-22.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantDefaultImage);
export default __webpack_public_path__ + "static/media/plantDefaultImage.719b0a36525dfc588a9eb1b0f87c2330.svg";
export { ForwardRef as ReactComponent };